import { render } from "./LowStockWidget.vue?vue&type=template&id=4d60d038"
import script from "./LowStockWidget.vue?vue&type=script&lang=js"
export * from "./LowStockWidget.vue?vue&type=script&lang=js"

import "./LowStockWidget.vue?vue&type=style&index=0&id=4d60d038&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__